export default Object.freeze({
  privacyPolicy: 'privacyPolicy',
  agreement: 'agreement'
})


// WEBPACK FOOTER //
// ./src/code/TermsType.js